import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import gql from 'graphql-tag';
import { ToastService } from 'ng-uikit-pro-standard';
import { BodegaService } from 'src/app/services/bodega.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { TipoMovimientoService } from 'src/app/services/tipo-movimiento.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from "src/app/shared/services/dates.service";
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalAddMovimientoComponent } from './modal-add-movimiento/modal-add-movimiento.component';
import { ModalViewMovimientoComponent } from './modal-view-movimiento/modal-view-movimiento.component';

@Component({
  selector: "app-exist-inventario",
  templateUrl: "./exist-inventario.component.html",
  styleUrls: ["./exist-inventario.component.scss"],
  providers: [SecurityService],
})
export class ExistInventarioComponent implements OnInit {

  @ViewChild('alert', { static: true }) alert: ElementRef;
  closeAlert() {
    this.alert.nativeElement.classList.remove('show');
  }

  // Modales
  @ViewChild(ModalAddMovimientoComponent, { static: true }) modalAgregarMovimiento: ModalAddMovimientoComponent
  @ViewChild(ModalViewMovimientoComponent, { static: true }) modalViewMovimiento: ModalViewMovimientoComponent

  // Form
  formData: FormGroup

  optionsBodega: Array<any> = [];
  optionsTipoMovimiento: Array<any> = [];
  optionsTipDocumento: Array<any> = []
  showBodegaEntrada: boolean = false
  showBodegaSalida: boolean = false

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  listaMovimientos: any = null
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false

  // Utils
  private log: any

  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private bodegaServ: BodegaService,
    private tipoMovimientoServ: TipoMovimientoService,
    private tipoDocumentoService: TipoDTEService,
    private clog: ConsoleService,
    private toastrService: ToastService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('INVENTARIO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 10

    // Bodegas
    this.bodegaServ.GetBodegas(this.rutEmpresa, this.sucursalEmpresa, ({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsBodega = registros.map(bodega => ({ value: bodega.codigo, label: bodega.nombre, sucursal_codigo: bodega.sucursal_codigo, codigo: bodega.codigo }))
    })

    // Tipos Movimiento
    this.tipoMovimientoServ.GetTiposMovimiento(({ mensajes, respuesta }) => {
      const { registros } = respuesta
      // this.optionsTipoMovimiento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, operacion: tipo.operacion }))
      this.optionsTipoMovimiento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.nombre, codigo: tipo.codigo, operacion: tipo.operacion }))
    })

    // Tipos documentos
    this.tipoDocumentoService.GetTiposDocumento(({ mensajes, respuesta }) => {
      const { registros } = respuesta
      this.optionsTipDocumento = registros.map(tipo => ({ value: tipo.codigo, label: tipo.descripcion }))
    })

    // Form and changes in Tipo Movimiento
    this.createForm()
    this.formChangesSubscriptions()
    // this.onChanges();

  }

  createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData = this.fb.group({
      fechaInicio: [initDate],
      fechaFin: [currentDate],
      tipoMovimiento: [[]],
      bodegaIngreso: [[]],
      bodegaSalida: [[]],
      numeroMovimiento: [0]
    });
  }

  formChangesSubscriptions() {
    this.formData.get("tipoMovimiento").valueChanges.subscribe((tipoMovimientoLista: Array<any>) => {
      this.log(tipoMovimientoLista)
      this.showBodegaEntrada = false
      this.showBodegaSalida = false

      const operacioneSeleccionadas = this.optionsTipoMovimiento.filter(tm => tipoMovimientoLista.includes(tm.value)).map(tm => tm.operacion)

      if (operacioneSeleccionadas.filter(op => op === 1 || op === 2).length > 0)
        this.showBodegaEntrada = true

      if (operacioneSeleccionadas.filter(op => op === -1 || op === 2).length > 0)
        this.showBodegaSalida = true
    })
  }

  // get showBodegaEntrada() {
  //   this.log('tipoMovimiento', this.formData.get('tipoMovimiento').value)
  //   return this.formData.get('tipoMovimiento').value === 1 || this.formData.get('tipoMovimiento').value === 2
  // }

  // get showBodegaSalida() {
  //   return this.formData.get('tipoMovimiento').value === -1 || this.formData.get('tipoMovimiento').value === 2
  // }

  // onChanges(): void {
  //   this.log('onChanges')
  //   this.formData.get('tipoMovimiento').valueChanges.subscribe(val => {
  //     this.log(val)
  //   });
  // }

  /********* MODAlS *********/
  abrirModalAgregarMovimiento() {
    this.modalAgregarMovimiento.show()
  }

  cerrarModalAgregarMovimiento() {
    this.modalAgregarMovimiento.hide()
  }

  abrirModalViewMovimiento() {
    const nroMov = this.formData.get("numeroMovimiento").value
    if (!nroMov || nroMov === 0) {
      this.toastrService.warning("Ingreso número de movimiento")
      return
    }
    this.modalViewMovimiento.load(this.rutEmpresa, nroMov)
  }

  cerrarModalViewMovimiento() {
    this.modalViewMovimiento.hide();
  }
  /********* MODAlS *********/


  /********* OPERATIONS *********/

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar()
  }

  buscar(fromStartPage: Boolean = false) {
    if (fromStartPage) this.paginationContext.CurrentPage = 1
    // // this.logs('this.formData.valid', this.formData.valid)
    // // this.logs('this.formData.errors', this.formData.errors)
    // // this.validateAllFormFields(this.formData);
    // // if (!this.formData.valid) {
    // //   return
    // // }
    const _variables = {
      empresa_rut: Number(this.rutEmpresa),
      sucursal_codigo: Number(this.sucursalEmpresa),
      filtro_tipo_movimiento: this.formData.get('tipoMovimiento').value ? this.formData.get('tipoMovimiento').value : [],
      filtro_bodega_ingreso: this.formData.get('bodegaIngreso').value,
      filtro_bodega_salida: this.formData.get('bodegaSalida').value,
      // filtro_fecha_inico: '0001-01-01',
      // filtro_fecha_final: '0001-01-01',
      filtro_fecha_inico: this.formData.get("fechaInicio").value ? this.formData.get("fechaInicio").value : '0001-01-01',
      filtro_fecha_final: this.formData.get("fechaFin").value ? this.formData.get("fechaFin").value : '0001-01-01',
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.log('_variables', JSON.stringify(_variables))

    this.loaded = false
    this.loading = true

    const self = this
    this.gqlclient.query(
      {
        query: gql`
        query(
          $empresa_rut: Decimal,
          $sucursal_codigo: Decimal,
          $filtro_tipo_movimiento: [Decimal],
          $filtro_bodega_ingreso: [Decimal],
          $filtro_bodega_salida: [Decimal],
          $filtro_fecha_inico: Date,
          $filtro_fecha_final: Date,
          $paginaActual: Int,
          $cantidadRegistrosPorPagina: Int)
        {
          movimiento_stock {
            obtenerMovimientoStockSegunFiltros (
              filtro: {
                exacto: {
                  rut_emisor: $empresa_rut,
                  sucursal_codigo: $sucursal_codigo,
                  fecha_inico: $filtro_fecha_inico,
                  fecha_final: $filtro_fecha_final
                }
              },
              filtro_tipo_movimiento: $filtro_tipo_movimiento,
              filtro_bodega_ingreso: $filtro_bodega_ingreso,
              filtro_bodega_salida: $filtro_bodega_salida,
              paginaActual: $paginaActual,
              cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina)
            {
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  codigo
                  sucursal_codigo
                  rut_emisor
                  fecha_movimiento
                  tipo_movimiento_nombre
                  bodega_nombre_ingreso
                  bodega_nombre_salida
                  costo_total
                  referencia
                }
              }
            }
          }
        }
         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        self.log(response)
        // const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(
        //   respuesta.data.cliente_proveedor.obtenerSegunFiltro
        // );
        // if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        // } else {
        //   alert(notificacion.mensajes[0].texto);
        // }

        const { mensajes, respuesta } = response.data.movimiento_stock.obtenerMovimientoStockSegunFiltros
        self.log(respuesta)
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        self.paginationContext.RecordsCount = totalRegistros
        self.paginationContext.CurrentPage = paginaActual
        self.paginationContext.PagesCount = totalPaginas
        self.log(self.paginationContext)
        self.listaMovimientos = registros
        self.loaded = true
        self.loading = false
      }
    );
  }

  loadMovimiento({ rut_emisor, codigo }) {
    this.modalViewMovimiento.load(rut_emisor, codigo)
  }

  onMovimientoInventarioSaved() {
    this.log("buscar desde main")
    this.buscar(true)
  }
  /********* OPERATIONS *********/
}
